'use es6';

import * as Editions from 'self-service-api/constants/Editions';
import * as Terms from 'self-service-api/constants/Terms';
import { ALL_SERVICES } from 'pricing-pages-lib/constants/AllAvailableServices';
import { STARTER } from 'self-service-api/constants/Editions';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
export const validateEditionOrGetDefault = (edition, defaultEdition = STARTER) => Object.values(Editions).includes(edition) ? edition : defaultEdition;
export const validateTermOrGetDefault = (term, defaultTerm = ANNUAL) => Object.values(Terms).includes(term) ? term : defaultTerm;
export const validateUnitQuantityOrGetDefault = (quantity, defaultQuantity = 0) => Number.isInteger(quantity) && quantity > -1 ? quantity : defaultQuantity;
export const validateAddOnsItemConfig = ({
  addOns
}) => {
  if (!addOns) return [];
  const addOnsArray = typeof addOns === 'string' ? [addOns] : addOns;
  const addOnsProductConfigs = [];
  addOnsArray.forEach(entry => {
    let apiName;
    let quantity;

    if (entry.toString().match(/\n*_\n*/)) {
      const [key, value] = entry.split('_');
      apiName = key;
      quantity = Number(value);
    } else {
      apiName = entry;
      quantity = 1;
    }

    if (ALL_AVAILABLE_ADD_ONS.includes(apiName)) {
      addOnsProductConfigs.push({
        apiName,
        quantity
      });
    }
  });
  return addOnsProductConfigs;
};
export const validateServicesOrGetDefault = (apiNames, defaultApiNames = []) => {
  if (!apiNames) return defaultApiNames;
  apiNames = typeof apiNames === 'string' ? [apiNames] : apiNames;
  const filtered = apiNames.filter(apiName => ALL_SERVICES.includes(apiName));
  return filtered.length === 0 ? defaultApiNames : filtered;
};